import React from 'react'

const Manual_personalizar_banner_principal = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          ¿Cómo personalizar tu banner principal?
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Modifica y adapta el banner principal de tu sitio para mejorar la imagen visual de tu e-commerce.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_personalizar_tu_banner_principal__wTQldLpITW-_s2qqCuqkaQ?as=scrollable"
          className="scribe-iframe-general-121"
          width="100%"
          height="5200"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_personalizar_banner_principal
